import { Column, Entity, JoinColumn, OneToMany, OneToOne, PrimaryGeneratedColumn } from 'typeorm';
import { Activite, BaseEntite, EntiteStatique, Produit } from '.';
import { Horaire } from './horaire.entity';
import { ModeleHoraireActivite } from './modele-horaire-activite.entity';
import { ModeleHoraireProduit } from './modele-horaire-produit.entity';

@EntiteStatique()
@Entity('modele_horaire')
export class ModeleHoraire implements BaseEntite {
    static key = 'modele-horaire';

    @PrimaryGeneratedColumn()
    id: number;

    @Column({ nullable: true })
    name: string;

    @Column({ type: 'boolean', nullable: true, default: true })
    actif = true;

    @Column({ nullable: true })
    fk_id_horaire: number;

    @OneToOne(() => Horaire, { cascade: true })
    @JoinColumn({ name: 'fk_id_horaire', referencedColumnName: 'id' })
    horaire: Horaire;

    @OneToMany(() => Activite, (activite: Activite) => activite.horaireParDefaut)
    activites: Activite[];

    @OneToMany(() => Produit, (produit: Produit) => produit.horaireParDefaut)
    produits: Produit[];

    @OneToMany(
        () => ModeleHoraireActivite,
        (modeleHoraireActivite: ModeleHoraireActivite) => modeleHoraireActivite.modeleHoraire,
        { cascade: true },
    )
    modeleHoraireActivite: ModeleHoraireActivite[];

    @OneToMany(
        () => ModeleHoraireProduit,
        (modeleHoraireProduit: ModeleHoraireProduit) => modeleHoraireProduit.modeleHoraire,
        { cascade: true },
    )
    modeleHoraireProduit: ModeleHoraireProduit[];
}
